import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface DischargeReasonParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface DischargeReason {
    id?: any;
    tenantId: any;
    branchId: any;
    name:string;
    isActive:string;
    
    parameters?: DischargeReasonParameter[];
    links?: any;
}


export abstract class DischargeReasonData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<DischargeReason[]>;
    abstract create(url: string, data: DischargeReason): Observable<DischargeReason[]>;
    abstract update(url: string, data: DischargeReason): Observable<DischargeReason>;
    abstract delete(url: string): Observable<any>;
}
